// extracted by mini-css-extract-plugin
export default {"page":"page--fwKEm","crumbs":"crumbs--JcO1E","content":"content--x9nuH"};